module.exports = __webpack_public_path__ + "static/media/Public_relations_1_A.d101adf2.png";